import { Box, Button } from '@mui/material'
import { GoogleLoginButton, googleUserAtom } from 'infrastructure/googleDrive'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { CollapsableJson } from 'shared/ui'
import React from 'react'
import { makeContentServiceGetRequest } from 'infrastructure/contentService'

export function DeveloperSandbox() {
  const guser = useAtomValue(googleUserAtom)
  const [kiddomUser, setKiddomUser] = React.useState<any>({})

  return (
    <Box>
      <h1>Developer Sandbox</h1>

      <Button
        variant="contained"
        color="primary"
        onClick={() => {
          makeContentServiceGetRequest('v1/auth/admin').then(async (s) => {
            setKiddomUser(await s.json())
          })
        }}
      >
        Authenticate Content Service
      </Button>

      {!guser.credential?.accessToken && (
        <GoogleLoginButton hideWhenLoggedIn={true} />
      )}

      <CollapsableJson title="Kiddom User" json={kiddomUser} />

      <CollapsableJson title="Google User" json={guser} />
    </Box>
  )
}
